import PropTypes from 'prop-types'
import React from "react";
import styles from './ContentBox.module.scss'
import Scroll from "../../../../partials/Scroll/Scroll";

function ContentBox({title = 'Title Here',variant, fitContent, children, htmlContent, ...rest}) {
    const titleClasses = `${styles.Title} 
            ${variant === 'blueish' ? styles.blueish : ''}
            ${variant === 'success' ? styles.success : ''}
            ${variant === 'failure' ? styles.failure : ''}`

    const boxClasses = `${styles.ContentBox}
            ${variant === 'blueish' ? styles.blueish : ''}
            ${variant === 'success' ? styles.success : ''}
            ${variant === 'failure' ? styles.failure : ''}`
    const contentClasses = `${styles.Content}
            ${variant === 'blueish' ? styles.blueish : ''}
            ${variant === 'success' ? styles.success : ''}
            ${variant === 'failure' ? styles.failure : ''}`

    if (htmlContent ) {
        return <div className={`${boxClasses}`} {...rest} >
            <div className={titleClasses
            } >{title}</div>
            <Scroll><div className={`${contentClasses}  ${fitContent ? styles.nogrow : ''}`}  dangerouslySetInnerHTML={{
                __html: htmlContent
            }}>
            </div></Scroll>
        </div> }
    return <div className={`${boxClasses}` } {...rest} >
        <div className={titleClasses} >{title}</div>
            <div className={`${styles.Content}  ${fitContent ? styles.nogrow : ''}`} >
                {children}
            </div>

    </div>
}
export default ContentBox;
ContentBox.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string
}
ContentBox.defaultProps = {
  children: <></>,
  title: '',
    fitContent: false,
}
